/**
 * Accessibility Fixes — thefrenchsimracer.com
 * Corrige les problèmes ARIA du carrousel Slick, du widget Instafeed,
 * et des liens de marques.
 */
(function () {
  "use strict";
  var labels = window.tfsAccessibilityLabels || {};

  /* ------------------------------------------------------------------ */
  /*  1.  SLICK SLIDER – correction complète des rôles et attributs     */
  /* ------------------------------------------------------------------ */
  var slickObserverStarted = false;
  var pendingSliders = new Set();
  var slickFrame = 0;

  function setSlickAttribute(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function normalizeSlick(slider) {
    if (!slider.isConnected || !slider.classList.contains("slick-initialized")) return;
    if (slider.getAttribute("role") === "toolbar") slider.removeAttribute("role");
    slider.querySelectorAll(".slick-track").forEach(function (track) {
      if (track.closest(".slick-initialized") !== slider) return;
      setSlickAttribute(track, "role", "group");
      var slides = Array.from(track.children).filter(function (slide) {
        return slide.classList.contains("slick-slide") && !slide.classList.contains("slick-cloned");
      });
      Array.from(track.children).forEach(function (slide) {
        if (!slide.classList.contains("slick-slide")) return;
        setSlickAttribute(slide, "role", "group");
        slide.removeAttribute("aria-selected");
        var description = slide.getAttribute("aria-describedby");
        if (description && (!document.getElementById(description) || document.getElementById(description).closest(".slick-dots"))) {
          slide.removeAttribute("aria-describedby");
        }
        var index = slides.indexOf(slide);
        if (index !== -1 && !slide.hasAttribute("aria-label")) {
          setSlickAttribute(slide, "aria-label", (index + 1) + " / " + slides.length);
        }
      });
    });
    slider.querySelectorAll(".slick-dots").forEach(function (dots) {
      if (dots.closest(".slick-initialized") !== slider) return;
      if (dots.tagName === "UL" || dots.tagName === "OL") dots.removeAttribute("role");
      else setSlickAttribute(dots, "role", "group");
      var items = Array.from(dots.children);
      items.forEach(function (item, index) {
        item.removeAttribute("role");
        ["aria-selected", "aria-hidden", "aria-controls", "aria-label", "tabindex"].forEach(function (name) {
          item.removeAttribute(name);
        });
        var button = item.querySelector("button");
        if (!button) return;
        button.removeAttribute("role");
        button.removeAttribute("aria-hidden");
        button.removeAttribute("aria-selected");
        setSlickAttribute(button, "tabindex", "0");
        setSlickAttribute(button, "aria-label", (index + 1) + " / " + items.length);
        setSlickAttribute(button, "aria-current", item.classList.contains("slick-active") ? "true" : "false");
        var controls = button.getAttribute("aria-controls");
        if (controls && !document.getElementById(controls)) button.removeAttribute("aria-controls");
      });
    });
    slider.querySelectorAll("button.slick-arrow").forEach(function (button) {
      var label = button.classList.contains("slick-prev") ? labels.previous : button.classList.contains("slick-next") ? labels.next : null;
      if (label) setSlickAttribute(button, "aria-label", label);
      if (!(button.getAttribute("aria-label") || button.textContent.trim())) return;
      button.querySelectorAll("svg").forEach(function (svg) {
        svg.removeAttribute("role");
        setSlickAttribute(svg, "aria-hidden", "true");
        setSlickAttribute(svg, "focusable", "false");
      });
    });
  }

  function queueSlick(element) {
    if (!element || element.nodeType !== 1) return;
    var slider = element.closest(".slick-initialized");
    if (slider) pendingSliders.add(slider);
    element.querySelectorAll(".slick-initialized").forEach(function (child) { pendingSliders.add(child); });
    if (!pendingSliders.size || slickFrame) return;
    slickFrame = window.requestAnimationFrame(function () {
      slickFrame = 0;
      var sliders = Array.from(pendingSliders);
      pendingSliders.clear();
      sliders.forEach(normalizeSlick);
    });
  }

  function fixSlickAria() {
    document.querySelectorAll(".slick-initialized").forEach(normalizeSlick);
  }

  var slickRootObservers = new WeakMap();
  var slickObserveOptions = {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["class", "role", "aria-hidden", "aria-selected", "aria-controls", "aria-describedby"]
  };

  function watchSlickRoot(slider) {
    if (slickRootObservers.has(slider)) return;
    var observer = new MutationObserver(function () {
      if (!slider.isConnected) {
        observer.disconnect();
        return;
      }
      if (!slider.classList.contains("slick-initialized")) return;
      observer.disconnect();
      normalizeSlick(slider);
      observer.observe(slider, slickObserveOptions);
    });
    slickRootObservers.set(slider, observer);
    if (slider.classList.contains("slick-initialized")) normalizeSlick(slider);
    observer.observe(slider, slickObserveOptions);
  }

  function watchSlickRoots() {
    document.querySelectorAll(".slideshow, .productView-nav, .productView-for, [data-announcement-bar], .slick-initialized").forEach(watchSlickRoot);
  }

  function observeSlickChanges() {
    watchSlickRoots();
    if (slickObserverStarted || !window.jQuery) return;
    slickObserverStarted = true;
    window.jQuery(document).on(
      "init.tfsA11y reInit.tfsA11y afterChange.tfsA11y breakpoint.tfsA11y",
      ".slick-initialized",
      function (event) {
        if (event.type === "afterChange") normalizeSlick(this);
        else queueSlick(this);
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /*  2.  INSTAFEED – ajouter role="button" sur les divs                */
  /* ------------------------------------------------------------------ */
  function fixInstafeed() {
    var items = document.querySelectorAll("[data-instafeed-role-button]");
    items.forEach(function (el) {
      /* Ajouter le rôle button pour que aria-haspopup soit autorisé */
      if (!el.getAttribute("role")) {
        el.setAttribute("role", "button");
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  3.  BRAND SLIDER – corriger les aria-label génériques             */
  /* ------------------------------------------------------------------ */
  function fixBrandAriaLabels() {
    var brandLinks = document.querySelectorAll("a.adaptive_height[aria-label]");
    brandLinks.forEach(function (link) {
      /* Extraire le nom de la marque depuis le texte frère ou le href */
      var textEl = link.closest(".wrapper-content, .block-item")?.querySelector(".text, .brand-title, h3, h4, .title");
      var brandName = "";

      if (textEl) {
        brandName = textEl.textContent.trim();
      }

      if (!brandName) {
        /* Essayer d'extraire depuis l'URL */
        var href = link.getAttribute("href") || "";
        var match = href.match(/\/collections\/([^?#]+)/);
        if (match) {
          brandName = match[1].replace(/-/g, " ").replace(/\b\w/g, function (c) {
            return c.toUpperCase();
          });
        } else if (href.includes("youtube.com")) {
          var chanMatch = href.match(/@(.+)/);
          brandName = chanMatch ? "Chaîne YouTube " + chanMatch[1] : "Chaîne YouTube";
        }
      }

      if (brandName) {
        link.setAttribute("aria-label", brandName);
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  4.  SLIDE IMAGES – ajouter aria-label aux liens du carrousel      */
  /* ------------------------------------------------------------------ */
  function fixSlideImageLinks() {
    var slideLinks = document.querySelectorAll("a.slide-image");
    slideLinks.forEach(function (link) {
      if (!link.getAttribute("aria-label")) {
        var href = link.getAttribute("href") || "";
        var match = href.match(/\/collections\/([^?#]+)/);
        if (match) {
          var name = match[1].replace(/-/g, " ").replace(/\b\w/g, function (c) {
            return c.toUpperCase();
          });
          link.setAttribute("aria-label", "Voir la collection " + name);
        }
      }
      /* Corriger aussi l'alt vide des images */
      var img = link.querySelector("img");
      if (img && !img.getAttribute("alt")) {
        var ariaLabel = link.getAttribute("aria-label");
        if (ariaLabel) {
          img.setAttribute("alt", ariaLabel);
        }
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  5.  ÉLÉMENTS STATIQUES (présents au chargement)                    */
  /* ------------------------------------------------------------------ */
  function fixStaticA11y() {
    /* #4 — SVG de recherche role="img" sans nom accessible */
    document.querySelectorAll('svg.icon-search').forEach(function (svg) {
      if (svg.getAttribute("role") === "img" && !svg.getAttribute("aria-label") && !svg.querySelector("title")) {
        if (labels.search) svg.setAttribute("aria-label", labels.search);
      }
    });

    /* #5 — Bouton newsletter : le nom accessible doit inclure le texte visible.
       Un aria-label divergent masque le texte → on le retire pour que le texte
       visible devienne le nom accessible. */
    document.querySelectorAll("button.newsletter-form__button").forEach(function (btn) {
      var visible = (btn.textContent || "").trim();
      var al = btn.getAttribute("aria-label");
      if (visible && al && al.indexOf(visible) === -1) {
        btn.removeAttribute("aria-label");
      }
    });

    /* #6 — Le titre "catégories" est un <h3> qui casse l'ordre des titres.
       Ce n'est pas un vrai titre de document → on le neutralise sémantiquement. */
    document.querySelectorAll(".categories-title h3.title, .vertical-menu h3.title").forEach(function (h) {
      h.setAttribute("role", "presentation");
    });

    /* #7 — H1 logo en double (header principal + header sticky/mobile) :
       une page ne doit avoir qu'un seul H1. On garde le premier H1 visible
       et on neutralise les autres (ils ne contiennent que le logo). */
    var logoH1s = document.querySelectorAll("h1.header__heading");
    if (logoH1s.length > 1) {
      var kept = false;
      logoH1s.forEach(function (h) {
        var visible = h.offsetParent !== null;
        if (visible && !kept) {
          h.removeAttribute("role");
          kept = true;
        } else {
          h.setAttribute("role", "presentation");
        }
      });
      if (!kept) { logoH1s[0].removeAttribute("role"); }
    }

    /* #8 — Titres de popups cachés qui polluent le plan de titres de
       TOUTES les pages : deux <h2>Options</h2> (popup list-view + popup carte
       mobile) et un <h5> vide. Ce sont des libellés de modale, pas des titres
       de document → on les sort du plan de titres. */
    document.querySelectorAll("#list-view-popup h2, #halo-card-mobile-popup h2").forEach(function (h) {
      h.setAttribute("role", "presentation");
    });

    /* Neutraliser tout titre VIDE (ex. <h5 class="halo-popup-title"> vide),
       sauf les H1 logo qui sont nommés par l'alt de leur image. */
    document.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach(function (h) {
      var hasText = (h.textContent || "").trim().length > 0;
      var namedImg = h.querySelector('img[alt]:not([alt=""])');
      if (!hasText && !namedImg && !h.classList.contains("header__heading")) {
        h.setAttribute("role", "presentation");
      }
    });

    /* #10 — Cibles tactiles trop petites (mobile) : agrandir la zone cliquable
       des liens texte des marques (brand slider). display:block garde le centrage
       du thème. Injecté une seule fois. */
    if (!document.getElementById("a11y-touch-target-style")) {
      var st = document.createElement("style");
      st.id = "a11y-touch-target-style";
      st.textContent = "@media (max-width:749px){.halo-row .wrapper-content a.text,.brand-slider a.text{display:block;min-height:24px;padding:8px 6px;line-height:1.5}}";
      (document.head || document.documentElement).appendChild(st);
    }
  }

  /* ------------------------------------------------------------------ */
  /*  INITIALISATION                                                     */
  /* ------------------------------------------------------------------ */
  function init() {
    fixStaticA11y();
    fixSlickAria();
    observeSlickChanges();
    fixInstafeed();
    fixBrandAriaLabels();
    fixSlideImageLinks();
  }

  /* Les éléments statiques sont corrigés tout de suite ; les éléments
     dynamiques (Slick/Instafeed) après leur initialisation différée. */
  function boot() {
    init();
    setTimeout(init, 1500);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* Filet de sécurité : ré-exécuter après chargement complet */
  window.addEventListener("load", function () {
    setTimeout(init, 2500);
  });
})();
